document.addEventListener("DOMContentLoaded", function () {
  class DynamicFiltersVisibility {
    constructor() {
      this.filtersButton = document.getElementById("filters-button");
      this.facetDrawer = document.getElementById("Facet-Drawer");
      this.tagsWrapper = document.querySelector(".collection-tags-wrapper");
      this.resizeTimeout = null;
      this.recheckTimeout = null;
      this.observer = null;

      this.init();
    }

    init() {
      this.refreshVisibility();

      setTimeout(() => this.refreshVisibility(), 400);
      setTimeout(() => this.refreshVisibility(), 1200);

      this.setupObservers();
      this.setupEvents();
    }

    isDesktop() {
      return window.innerWidth > 1024;
    }

    refreshVisibility() {
      this.hideMainFilters();
      this.checkFiltersAvailability();
    }

    hideMainFilters() {
      if (!this.facetDrawer) return;

      const allFilters = this.facetDrawer.querySelectorAll("details.thb-filter.js-filter");

      allFilters.forEach((filter) => {
        const filterTitle = filter.querySelector(".thb-filter-title");
        if (!filterTitle) return;

        const titleText = filterTitle.textContent.trim().toLowerCase();

        const desktopMainFilters = [
          "price",
          "delivery speed",
          "video certified"
        ];

        const alwaysHiddenFilters = [
          "popular",
          "popularity",
          "populares",
          "popularidad",
          "popular searches",
          "búsquedas populares"
        ];

        const isDesktopMainFilter =
          this.isDesktop() &&
          desktopMainFilters.some((mainFilter) => titleText.includes(mainFilter));

        const isAlwaysHiddenFilter = alwaysHiddenFilters.some((hiddenFilter) =>
          titleText.includes(hiddenFilter)
        );

        filter.style.display = isDesktopMainFilter || isAlwaysHiddenFilter ? "none" : "";
      });
    }

    checkFiltersAvailability() {
      if (!this.filtersButton) return;

      if (!this.isDesktop()) {
        this.showFiltersButton();
        this.updateTagsSlider();
        return;
      }

      const hasExtraFilters = this.detectExtraFilters();

      if (hasExtraFilters) {
        this.showFiltersButton();
      } else {
        this.hideFiltersButton();
      }

      this.updateTagsSlider();
    }

    detectExtraFilters() {
      if (!this.facetDrawer) return false;

      const visibleFilters = this.facetDrawer.querySelectorAll(
        'details.thb-filter.js-filter:not([style*="display: none"])'
      );

      let extraFiltersCount = 0;

      visibleFilters.forEach((filter) => {
        const filterTitle = filter.querySelector(".thb-filter-title");
        const filterContent = filter.querySelector(".thb-filter-content");

        if (!filterTitle || !filterContent) return;

        const titleText = filterTitle.textContent.trim().toLowerCase();

        const systemFilters = [
          "popular searches",
          "búsquedas populares",
          "popular",
          "popularity",
          "populares",
          "popularidad",
          "sort by",
          "ordenar por"
        ];

        const isSystemFilter = systemFilters.some((systemFilter) =>
          titleText.includes(systemFilter)
        );

        if (!isSystemFilter) {
          const checkboxes = filterContent.querySelectorAll('input[type="checkbox"]');
          const radios = filterContent.querySelectorAll('input[type="radio"]');

          if (checkboxes.length > 0 || radios.length > 0) {
            extraFiltersCount++;
          }
        }
      });

      return extraFiltersCount > 0;
    }

    showFiltersButton() {
      if (!this.filtersButton) return;

      this.filtersButton.style.display = "";
      this.filtersButton.style.visibility = "visible";
      this.filtersButton.style.opacity = "1";
      this.filtersButton.classList.remove("hidden", "hide");
      this.filtersButton.classList.add("show");

      if (this.tagsWrapper) {
        this.tagsWrapper.classList.add("has-filters-button");
        this.tagsWrapper.classList.remove("no-filters-button");
      }

      document.body.classList.remove("no-extra-filters");
    }

    hideFiltersButton() {
      if (!this.filtersButton) return;

      this.filtersButton.classList.remove("show");
      this.filtersButton.classList.add("hidden", "hide");

      setTimeout(() => {
        if (this.filtersButton && this.filtersButton.classList.contains("hidden")) {
          this.filtersButton.style.display = "none";
          this.filtersButton.style.visibility = "hidden";
          this.filtersButton.style.opacity = "0";
        }
      }, 300);

      if (this.tagsWrapper) {
        this.tagsWrapper.classList.remove("has-filters-button");
        this.tagsWrapper.classList.add("no-filters-button");
      }

      document.body.classList.add("no-extra-filters");
    }

    updateTagsSlider() {
      if (
        window.globalCollectionTagsSlider &&
        typeof window.globalCollectionTagsSlider.refresh === "function"
      ) {
        window.globalCollectionTagsSlider.refresh();
        return;
      }

      if (!window.globalCollectionTagsSlider && window.CollectionTagsSlider) {
        setTimeout(() => {
          const slider = new window.CollectionTagsSlider(
            ".collection-tags",
            ".collection-tags-nav--prev",
            ".collection-tags-nav--next",
            ".collection-tags-indicator"
          );
          window.globalCollectionTagsSlider = slider;
        }, 100);
      }
    }

    queueRefresh(delay = 120) {
      clearTimeout(this.recheckTimeout);
      this.recheckTimeout = setTimeout(() => {
        this.refreshVisibility();
      }, delay);
    }

    setupObservers() {
      if (!this.facetDrawer) return;

      if (this.observer) this.observer.disconnect();

      this.observer = new MutationObserver((mutations) => {
        let shouldRecheck = false;

        mutations.forEach((mutation) => {
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            shouldRecheck = true;
          }

          if (mutation.type === "childList") {
            shouldRecheck = true;
          }
        });

        if (shouldRecheck) {
          this.queueRefresh(120);
        }
      });

      this.observer.observe(this.facetDrawer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "style"]
      });
    }

    setupEvents() {
      window.addEventListener("popstate", () => {
        this.queueRefresh(200);
      });

      document.addEventListener("filtersUpdated", () => {
        this.queueRefresh(200);
      });

      document.addEventListener("facet:updated", () => {
        this.queueRefresh(250);
      });

      window.addEventListener("resize", () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.refreshVisibility();
        }, 150);
      });
    }

    destroy() {
      if (this.observer) this.observer.disconnect();
      clearTimeout(this.resizeTimeout);
      clearTimeout(this.recheckTimeout);
    }
  }

  if (window.dynamicFiltersVisibility && window.dynamicFiltersVisibility.destroy) {
    window.dynamicFiltersVisibility.destroy();
  }

  window.dynamicFiltersVisibility = new DynamicFiltersVisibility();

  let currentPath = window.location.pathname + window.location.search;

  const pathObserver = new MutationObserver(() => {
    const newPath = window.location.pathname + window.location.search;

    if (newPath !== currentPath) {
      currentPath = newPath;
      window.dynamicFiltersVisibility.queueRefresh(300);
    }
  });

  pathObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});